var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMe)?_c('h2',{staticClass:"c-block-title"},[_c('en',{attrs:{"s":_vm.t}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }